import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/bg.png'
import _imports_1 from '@/assets/img/large-logo.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-59451fca")

_pushScopeId("data-v-59451fca")
const _hoisted_1 = { class: "top" }
const _hoisted_2 = { class: "bg-img" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  width: "1366"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  width: "687",
  class: "top-logo"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LoginForm = _resolveComponent("LoginForm")
  const _component_Footer = _resolveComponent("Footer")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode(_component_LoginForm, { class: "form" }),
      _createVNode("footer", null, [
        _createVNode(_component_Footer)
      ])
    ])
  ]))
})